import React from 'react';
export const closeSvg = () => {
    return (
        <svg viewBox="0 0 24 24" width="24" height="24" className="">
            <path fill="#565671"
    d="m19.8 5.8-1.6-1.6-6.2 6.2-6.2-6.2-1.6 1.6 6.2 6.2-6.2 6.2 1.6 1.6 6.2-6.2 6.2 6.2 1.6-1.6-6.2-6.2 6.2-6.2z"/>
        </svg>
    )
}